import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

export default makeStyles((theme: Theme) => ({
    Wrapper: {
        height: "auto",
        width: "100%", 
        position: "relative",
    },
    ToMain: {
        fontSize: "20px",
        cursor: "pointer"
    },
    StatusesList: {
        zIndex: 10,
        display: "flex",
        alignItems: "center",
        gap: "16px",
        height: "50px",
        maxWidth: "calc(100% - 80px)",
        overflowX: "auto",
        overflowY: "hidden",
        whiteSpace: "nowrap",
        scrollbarWidth: "thin",
        '&::-webkit-scrollbar': { height: 4 },
        '&::-webkit-scrollbar-thumb': { background: '#f0c99a', borderRadius: 4 },
        'a': {
            margin: "0",
        },
        '& p': {
            fontSize: "15px",
        },
        '& span': {
            color: "orange",
            fontSize: "18px",
        }
    },
    StatusCell: {
        direction: 'rtl',
        margin: "0",
        paddingLeft: "5px",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        '& span': {
            color: "#fc7f03",
        }
    },
    StatusRow:  {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    TableHeader: {
        backgroundColor: "#fc7f03",
    },
    Panel: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginInlineStart: "20px",
    }
}));
